/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {CountryCode} from "./countryCode.zod";
import {HelicopterSpecification} from "./helicopterSpecification.zod";
import {HeliportClassification} from "./heliportClassification.zod";
import {HeliportEnvironment} from "./heliportEnvironment.zod";
import {HeliportFireFighting} from "./heliportFireFighting.zod";
import {HeliportMisc} from "./heliportMisc.zod";
import {HeliportSize} from "./heliportSize.zod";
import {HeliportStandards} from "./heliportStandards.zod";
import {HeliportStructure} from "./heliportStructure.zod";
import {HeliportVisualAid} from "./heliportVisualAid.zod";

export const ExpedientEditableFields = zod.object({
  name: zod.string(),
  alias: zod.string(),
  description: zod.string(),
  country: CountryCode,
  location: HeliportEnvironment,
  size: HeliportSize,
  helicopter: HelicopterSpecification,
  classification: zod.union([HeliportClassification, zod.null()]).optional(),
  standard: HeliportStandards,
  structure: zod.union([HeliportStructure, zod.null()]).optional(),
  visualAid: zod.union([HeliportVisualAid, zod.null()]).optional(),
  fireFighting: zod.union([HeliportFireFighting, zod.null()]).optional(),
  misc: zod.union([HeliportMisc, zod.null()]).optional(),
});

export type ExpedientEditableFields = zod.input<typeof ExpedientEditableFields>;
export type ExpedientEditableFieldsOutput = zod.output<typeof ExpedientEditableFields>;
